import { motion } from "framer-motion";
import { useLocale } from "next-intl";
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
import * as AiIcons from "react-icons/ai";
import * as HiIcons from "react-icons/hi";
import * as IoIcons from "react-icons/io";
import * as Io2Icons from "react-icons/io5";
import * as BiIcons from "react-icons/bi";
import { useGetWhyChoose } from "../hooks/main-hooks";
export default function Pillars() {
  const { data } = useGetWhyChoose();
  const locale = useLocale();

  const pillars = data?.reasons || [];

  const allIcons = {
    ...FaIcons,
    ...MdIcons,
    ...AiIcons,
    ...HiIcons,
    ...IoIcons,
    ...Io2Icons,
    ...BiIcons,
  };

  return (
    <div className="grid gap-10 md:grid-cols-2">
      {pillars?.map((item: any, idx: number) => {
        const IconComponent = allIcons[item.icon as keyof typeof allIcons];

        return (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: idx * 0.15 }}
            viewport={{ once: true }}
            className="group relative rounded-2xl border border-slate-200 bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
          >
            <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-xl bg-[#c9a24d]/15 text-[#c9a24d] transition group-hover:scale-110">
              <IconComponent size={28} />
            </div>
            <h3 className="mb-3 text-2xl font-bold text-[#0a1b2e]">
              {item?.title?.[locale]}
            </h3>
            <p className="leading-relaxed text-[#132b44]">
              {item?.description?.[locale]}
            </p>
          </motion.div>
        );
      })}
    </div>
  );
}
